export default function audioSeries() {
  return {
    _id: false,
    isShared: false,
    templateRegion: false,
    type: 'droplet.audioSeries',
    episodes: [],
    episodesJSON: '{ "list": [] }',
    mediaQueries: [
      {
        global: true,
        selector: '.drzAudio',
        properties: [
          {
            property: 'transform',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: ', .drzAudio',
        properties: [
          {
            property: 'display',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzAudio-controls',
        properties: [
          {
            property: 'color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzAudio-volSlider::-webkit-slider-thumb',
        properties: [
          {
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzAudio-volSlider::-moz-range-thumb',
        properties: [
          {
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzAudio-volSlider::-ms-thumb',
        properties: [
          {
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzAudio-progress',
        properties: [
          {
            defaultColor: true,
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    bounceDroplet: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/audio-series/droplet.schema.js